export const COOKIE_NAME = 'kitpet-auth-cookie';
